var isNil = require('./type/is-nil');

function toString(value) {
  if (isNil(value)) return '';
  return value.toString();
}

module.exports = toString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/to-string.js
// module id = 15
// module chunks = 0